var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f937bca54693a06ce89198371a2390beeaf177bb"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["samsam-za@ferre-mekelenkamp"]={id:"f937bca54693a06ce89198371a2390beeaf177bb"};
      